import { render } from "./Radio.vue?vue&type=template&id=3649f7a0"
import script from "./Radio.vue?vue&type=script&lang=js"
export * from "./Radio.vue?vue&type=script&lang=js"
script.render = render

export default script